import { useCallback, useContext } from 'react';
import AccountPickerContext from '../../../../../../contexts/AccountPickerContext';
import isDefined from '../../../../../../isDefined';
import STORE from '../../../../../../store';
import { FindAndReplace } from '../../types';
import CompoundMetricsContext from '../../../../../../contexts/CompoundMetricsContext';
import invalidateMetricCache from '../../../../../../api/metrics/invalidateMetricCache';

const useFindAndReplaceCompoundMetrics = () => {
  const { allCompoundMetrics: compoundMetrics } = useContext(
    CompoundMetricsContext,
  );
  const { selectedAccountId } = useContext(AccountPickerContext);

  const replaceCompoundMetrics = useCallback(
    async (metricReceipt: FindAndReplace.MetricReceipt) => {
      const { findMetricId, replaceMetricId } = metricReceipt;

      const affectedCompoundMetricIds =
        metricReceipt.affectedContentIds.compoundMetrics;

      if (!affectedCompoundMetricIds?.length) {
        return;
      }

      const compoundMetricPromises = affectedCompoundMetricIds
        .map((cmId) => compoundMetrics.find((cm) => cm.id === cmId))
        .filter(isDefined)
        .map((compoundMetric) => {
          const newCompoundMetric: Metrics.CompoundMetric = {
            ...compoundMetric,
            metricIds: compoundMetric.metricIds.map((metricId) =>
              metricId === findMetricId ? replaceMetricId : metricId,
            ),
          };

          return STORE.metricDefinitions
            .getCompoundMetricsRef({ accountId: selectedAccountId })
            .doc(compoundMetric.id)
            .set(newCompoundMetric);
        });

      await Promise.all(compoundMetricPromises);

      await invalidateMetricCache({
        accountId: selectedAccountId,
        compoundMetricIds: affectedCompoundMetricIds,
      });
    },
    [compoundMetrics, selectedAccountId],
  );

  return replaceCompoundMetrics;
};

export default useFindAndReplaceCompoundMetrics;
